// extracted by mini-css-extract-plugin
module.exports = {"empty-view":"empty-view___2GsCS"};